module.exports = __webpack_public_path__ + "img/img_03.d8bfe5c9.png";